// Copyright © 2021 Move Closer
import { DeMarked, TokenizerError as DeMarkedTokenizerError, storageFactory, ErrorHandlingPolicy } from '@d24/demarked';
import { SimpleModuleAdapter } from './SimpleModuleAdapter';
export { DeMarked, DeMarkedTokenizerError };
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const createDeMarked = () => {
    const storage = storageFactory();
    return new DeMarked(new SimpleModuleAdapter(), storage, { errorHandlingPolicy: ErrorHandlingPolicy.CatchAndError });
};
